"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const CollapseMe = _ref => {
  let {
    isExpanded,
    children
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "donation-encourager__collapse-me",
    hidden: !isExpanded
  }, children);
};

var _default = CollapseMe;
exports.default = _default;